import { APIS } from "utils/constants";
import { axiosInstance } from "./index";

export interface IBadgeSettings {
  id: number;
  teamId: number;
  starterThreshold: number;
  contributorThreshold: number;
  achieverThreshold: number;
  championThreshold: number;
  level1Threshold: number;
  level2Threshold: number;
  level3Threshold: number;
  level4Threshold: number;
  level5Threshold: number;
  updatedAt: number;
}

export interface UpdateBadgeSettingsDto {
  starterThreshold?: number;
  contributorThreshold?: number;
  achieverThreshold?: number;
  championThreshold?: number;
  level1Threshold?: number;
  level2Threshold?: number;
  level3Threshold?: number;
  level4Threshold?: number;
  level5Threshold?: number;
}

export const getBadgeSettings = async (): Promise<IBadgeSettings> => {
  const res = await axiosInstance.get(APIS.BADGES.SETTINGS);
  return res.data;
};

export const updateBadgeSettings = async (
  data: UpdateBadgeSettingsDto
): Promise<IBadgeSettings> => {
  const res = await axiosInstance.put(APIS.BADGES.SETTINGS, data);
  return res.data;
};

// Helper to get tier display info
export const TIER_CONFIG: Record<
  string,
  { label: string; color: string; bgColor: string; icon: string }
> = {
  starter: {
    label: "Starter",
    color: "#6B7280",
    bgColor: "#F3F4F6",
    icon: "🌱"
  },
  contributor: {
    label: "Contributor",
    color: "#2563EB",
    bgColor: "#EFF6FF",
    icon: "⭐"
  },
  achiever: {
    label: "Achiever",
    color: "#D97706",
    bgColor: "#FFFBEB",
    icon: "🏅"
  },
  champion: {
    label: "Champion",
    color: "#7C3AED",
    bgColor: "#F5F3FF",
    icon: "🏆"
  }
};

export const LEVEL_CONFIG: Record<
  number,
  { label: string; color: string; icon: string }
> = {
  1: { label: "Level 1", color: "#6B7280", icon: "⚡" },
  2: { label: "Level 2", color: "#2563EB", icon: "⚡⚡" },
  3: { label: "Level 3", color: "#D97706", icon: "🔥" },
  4: { label: "Level 4", color: "#DC2626", icon: "🔥🔥" },
  5: { label: "Level 5", color: "#7C3AED", icon: "💎" }
};
